import { useEffect, useRef, useState } from 'react';
import { format, parseISO } from 'date-fns';
import { useAppStore } from '../../stores/appStore';
import { notesApi } from '../../lib/api';

export function MessagesWidget() {
  const messages = useAppStore((s) => s.messages);
  const user = useAppStore((s) => s.user);
  const refresh = useAppStore((s) => s.refreshWidgetsData);
  const [text, setText] = useState('');
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length]);

  async function send() {
    if (!text.trim() || !user) return;
    await notesApi.postMessage(text.trim());
    setText('');
    await refresh();
  }

  return (
    <div className="flex h-full flex-col">
      <h3 className="mb-2 text-sm font-bold uppercase tracking-wide text-slate-400">
        Message board
      </h3>
      <div className="flex-1 space-y-2 overflow-auto pr-1">
        {messages.slice(-30).map((m) => (
          <div
            key={m.id}
            className="rounded-xl bg-slate-800/60 px-2.5 py-1.5 light:bg-slate-100"
          >
            <div className="flex items-baseline justify-between gap-2">
              <span className="text-xs font-bold text-violet-300">
                {m.author_name}
              </span>
              <span className="text-[10px] text-slate-500">
                {format(parseISO(m.created_at), 'MMM d h:mm a')}
              </span>
            </div>
            <p className="text-sm leading-snug">{m.content}</p>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
      {user && (
        <div className="mt-2 flex gap-1">
          <input
            className="min-w-0 flex-1 rounded-lg border border-slate-600 bg-slate-800 px-2 py-1.5 text-sm outline-none focus:border-violet-500"
            placeholder="Leave a note for the family…"
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && void send()}
          />
          <button
            type="button"
            onClick={() => void send()}
            className="rounded-lg bg-violet-600 px-3 py-1 text-sm font-bold text-white"
          >
            Send
          </button>
        </div>
      )}
    </div>
  );
}
